import type { JobStep } from "./api";

const STEP_CONFIG: Record<JobStep, { label: string; progress: number }> = {
  CREATED: { label: "Preparing...", progress: 5 },
  EXTRACTING_AUDIO: { label: "Extracting audio...", progress: 15 },
  AUDIO_EXTRACTED: { label: "Audio extracted...", progress: 30 },
  TRANSCRIBING: { label: "Transcribing audio...", progress: 50 },
  TRANSCRIBED: { label: "Analyzing content...", progress: 70 },
  PROCESSING_TRANSCRIPT: { label: "Generating reports...", progress: 85 },
};

export function getStepLabel(step: JobStep): string {
  return STEP_CONFIG[step]?.label ?? "Processing...";
}

export function getStepProgress(step: JobStep): number {
  return STEP_CONFIG[step]?.progress ?? 10;
}
